import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {DcContextService} from '@ccp/services/dc/dc-context.service';
import {Views} from '@ccp/config/views';

export const DigitalCertificateContextGuard: CanActivateFn = (route) => {
  const dcContextService = inject(DcContextService);
  const router = inject(Router);
  if (dcContextService.hasDcDetails$()) {
    return true;
  } else {
    return router.createUrlTree([Views.productRegisterScanQrCode.path], {
      queryParams: {...route.queryParams},
    });
  }
};
